import { render, staticRenderFns } from "./SiatPraticheEditComponent.vue?vue&type=template&id=50f25eac&scoped=true"
import script from "./SiatPraticheEditComponent.vue?vue&type=script&lang=js"
export * from "./SiatPraticheEditComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatPraticheEditComponent.vue?vue&type=style&index=0&id=50f25eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f25eac",
  null
  
)

export default component.exports